import { TblSortDir } from '../table.types';

export function sortDateFn(col: string, dir: TblSortDir): (a: any, b: any) => number {
    return (a, b) => {
        const aVal = a[col] == null ? '' : `${a[col]}`;
        const bVal = b[col] == null ? '' : `${b[col]}`;
        const aValDate = new Date(aVal).getTime();
        const bValDate = new Date(bVal).getTime();
        const aNaN = isNaN(aValDate);
        const bNaN = isNaN(bValDate);
        if (aNaN && bNaN) return 0;
        if (aNaN) return 1; // nulls sort last
        if (bNaN) return -1;
        if (aValDate === bValDate) {
            return 0;
        }
        // DSC = newest to oldest, ASC = oldest to newest
        return dir === 'DSC' ? bValDate - aValDate : aValDate - bValDate;
    };
}
